import { Content } from "Content";
import { Footer } from "Footer";
import { Header } from "Header";

export const Home = ({ setModalDialog }) => {
  return (
    <>
      <Header homeNavOnly={false} />
      <Content setModalDialog={setModalDialog} />
      <Footer setModalDialog={setModalDialog} />
    </>
  );
};
